import { DialogContentText, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";

const InstructionAlertModal = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description1"
    >
      <DialogTitle textAlign="center" id="alert-dialog-title">
        {t("instructionAlertModal.title")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description3">
          <Typography color="black" variant="subtitle-1">
            {t("instructionAlertModal.subtitle")}
          </Typography>
        </DialogContentText>
        <ol>
          <li> {t("instructionAlertModal.text1")}</li>
          <li> {t("instructionAlertModal.text2")}</li>
          <li> {t("instructionAlertModal.text3")}</li>
        </ol>
        <DialogContentText id="alert-dialog-description3">
          <Typography color="black" variant="subtitle-1" fontWeight="bold">
            {t("giftPage.infoInstallModalSubTitle")}
          </Typography>
        </DialogContentText>
        <DialogContentText id="alert-dialog-description3">
          {t("giftPage.infoInstallModalText")}
        </DialogContentText>
        <DialogContentText id="alert-dialog-description4">
          {t("giftPage.infoInstallModalText2")}
        </DialogContentText>
        <DialogContentText id="alert-dialog-description5">
          {t("giftPage.infoInstallModalText2")}
        </DialogContentText>
        <DialogContentText
          sx={{ marginTop: "12px" }}
          id="alert-dialog-description2"
        >
          {t("instructionAlertModal.text5")}
        </DialogContentText>
        <DialogContentText
          sx={{ marginTop: "12px" }}
          id="alert-dialog-description2"
        >
          {t("instructionAlertModal.text4")}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={onConfirm} autoFocus>
          {t("alertDialog.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default InstructionAlertModal;
